<template>
  <div class="page-heading">
    <div class="start">
      <h1 v-if="pageTitle && pageTitle.length" class="pageTitle">
        {{ pageTitle }}
        <scale-tooltip
          v-if="tooltip.length"
          :content="tooltip"
          placement="right-end"
          @click="onClickTooltip"
        >
          <scale-icon class="cursor" name="info" />
        </scale-tooltip>
        <span>
          <slot name="iconModal" />
        </span>
      </h1>
      <slot v-else name="page-title" />
      <div v-if="isSubHeading" class="sub-heading">
        <slot name="page-sub-title" />
      </div>
    </div>
    <div class="right">
      <slot name="last" />
    </div>
  </div>
</template>

<script lang="ts" setup>
// define emits
const emit = defineEmits(["tooltip-click"])

// props
defineProps({
  pageTitle: {
    default: "",
    type: String,
    required: false
  },
  isSubHeading: {
    default: false,
    type: Boolean,
    required: false
  },
  tooltip: {
    default: "",
    type: String,
    required: false
  }
})

// emits tooltip clicked event
const onClickTooltip = () => {
  emit("tooltip-click")
}
</script>
<style lang="scss" scoped>
@use "@/styles/mixins/typography.scss" as *;

.page-heading {
  margin-top: var(--scl-spacing-40);
  margin-bottom: var(--scl-spacing-24);
  display: flex;
  align-items: center;

  .pageTitle {
    @include tg-heading-2;
    color: var(--telekom-color-text-and-icon-standard);

    > span {
      cursor: pointer;
    }
  }

  .sub-heading {
    color: var(--telekom-color-text-and-icon-standard);
  }

  .right {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
}
</style>
